/* @flow */
import { Record, Map, Set, fromJS } from 'immutable';
import createDebugger from 'debug';
import type { EntityTypeObject } from 'modules/miscellaneous/types.js';

const debug = createDebugger('app:modules:templates:types'); // eslint-disable-line no-unused-vars

export const ENCLAVE_TEMPLATES_ENDPOINT = '/services/enclave-templates';

export const NONE = 'NONE';
export const READ_ONLY = 'READ_ONLY';
export const READ_CREATE = 'READ_CREATE';
export const READ_WRITE = 'READ_WRITE';

type AccessType =
  'NONE'
  | 'READ_ONLY'
  | 'READ_CREATE'
  | 'READ_WRITE';

export type RawOptions = {
  query?: string,
  sortBy?: string,
  sortOrder?: 'ASC' | 'DESC',
};

export type TemplateObject = {
  id: string,
  name: string,
  description: string,
  iconUrl?: string,
  iconSvgUrl?: string,
  externalUrl?: string,
  maximumAccess?: AccessType,
  credentialsType: '',
  entityTypes?: Set<EntityTypeObject>,
  ingestSource?: string,
  label: string,
  subscriptionMethod: string,
};

export const Options = Record({
  query: '',
  sortBy: 'name',
  sortOrder: 'DESC',
});

/**
 * Should not be used directly. Use createEnclave since that ensures there's a
 * color prop
 */
export const _EnclaveTemplate = Record({
  id: null,
  name: '',
  description: '',
  iconUrl: '',
  iconSvgUrl: '',
  externalUrl: '',
  maximumAccess: null,
  credentialsType: null,
  ingestSource: '',
  entityTypes: null,
  label: null,
  subscriptionMethod: null,
  workflowSupported: false,
});

export type EnclaveTemplate = typeof _EnclaveTemplate;

/**
 * Creates an enclave template. Must pass an existing object with
 * an id attribute
 */
export const fromJson = (x: Object | Map<string, *>) => {
  const map = Map(x)
    .update('entityTypes', xs => xs ? fromJS(xs) : fromJS([])); // Instantiate array to list if present

  return _EnclaveTemplate(map);
};

export const toJson = (x: Object | Map<string, *>) => {
  return _EnclaveTemplate(
    x.update('entityTypes', entityTypes => entityTypes.map(et => et.keySeq()))
  );
};



// WEBPACK FOOTER //
// ./src/app/modules/templates/types.js